<template>
  <div class="section section--offers">
    <h2 class="section__title">Share Listings from a Brand</h2>
    <div class="section__container">
      <div class="section__content" v-if="isLoggedIn">
        <div class="details">
          <div v-if="allBrands.length > 0">
            <label>Brand</label>
            <v-select v-model="brand" :options="allBrands" />
          </div>
          <div>
            <label>Count</label>
            <span class="range">
              <span class="range__display">
                <span
                  class="range__display__value range__display__value--large"
                  >{{ count }}</span
                >
                listings
              </span>
              <input
                v-model="count"
                type="range"
                class="range__input"
                min="10"
                max="2000"
                step="10"
              />
            </span>
          </div>
        </div>
        <div class="info">
          <h3 class="info__title"></h3>
        </div>
        <div class="controls">
          <a
            class="control control--send"
            :class="this.brand ? '' : 'control--disabled'"
            @click="shareQuery"
            href="javascript:void(0)"
          >
            Share listings
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: { vSelect },
  data() {
    return {
      count: 100,
      brand: null,
      allBrands: [],
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    shareQuery() {
      if (this.hasFilters && !this.listingsCount) {
        return;
      }
      this.$store.dispatch('shareQuery', {
        count: this.count,
        query: this.brand,
      });
    },
    async updateCatalog() {
      this.allBrands = await this.$store.dispatch('fetchBrands');
    },
  },
  created() {
    return this.updateCatalog();
  },
  watch: {
    filters() {
      this.fetchListingsCount();
    },
    department() {
      this.category = null;
      this.subCategory = null;
    },
    category() {
      this.subCategory = null;
    },
  },
};
</script>
